import { App, ConfigProvider, ThemeConfig } from "antd";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { setNotificationAPI } from "../../Services/notificationService";

const AppApiCapture = ({ children }: { children: React.ReactNode }) => {
  const { notification } = App.useApp();
  useEffect(() => {
    setNotificationAPI(notification);
  }, [notification]);
  return <>{children}</>;
};

const AntDConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const intl = useIntl();
  const OverrideStyle: ThemeConfig = {
    token: {
      colorPrimary: "#c10505",
      colorInfo: "#000000",
      colorSplit: "#EAEAEA",
      fontFamily: "var(--font-inter), sans-serif"
    },
    components: {
      Divider: {
        colorSplit: "#EAEAEA"
      },
      // v6 clips notices to a fixed-width list holder, so widen via token, not CSS min-width
      Notification: {
        width: 450
      },
    }
  };
  return (
    <ConfigProvider
      theme={OverrideStyle}
      direction={intl.locale === "en" ? "ltr" : "rtl"}
    >
      <App>
        <AppApiCapture>
          {children}
        </AppApiCapture>
      </App>
    </ConfigProvider>
  );
};

export default AntDConfigProvider;
